import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_subscribe_modal = _resolveComponent("user-subscribe-modal")!

  return ($data.open)
    ? (_openBlock(), _createBlock(_component_user_subscribe_modal, {
        key: 0,
        "org-name": this.orgName,
        subscribeKey: this.key,
        onClose: $options.onClose
      }, null, 8 /* PROPS */, ["org-name", "subscribeKey", "onClose"]))
    : _createCommentVNode("v-if", true)
}